module.exports = __webpack_public_path__ + "img/media-16.b8235093.png";